export const formatPhoneNumber = (value: string): string => {
  const cleaned = value.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (match) {
    let part1 = '';
    if (match[1] && match[2]) {
      part1 = `(${match[1]}) ${match[2]}`;
    } else if (match[1]) {
      part1 = match[1];
    }
    const part3 = match[3] ? ` ${match[3]}` : '';
    return `${part1}${part3}`;
  }
  return value;
};

export const cleanPhoneNumber = (value: string): string => {
  return value.replace(/\D/g, '');
};
